<template>
  <table class="table table-sm">
    <thead>
      <tr>
        <th class="text-left align-top" scope="col" v-dynamic-content:pv_overview_column_years></th>
        <th
          class="text-right align-top"
          scope="col"
          v-dynamic-content:pv_overview_column_production
        ></th>
        <th
          class="text-right align-top"
          scope="col"
          v-dynamic-content:pv_overview_column_savings
        ></th>
        <th
          v-if="
            quote.detailOverview.annualSubsidies &&
            Object.keys(quote.detailOverview.annualSubsidies).length > 0
          "
          class="text-right align-top"
          scope="col"
          v-dynamic-content:pv_overview_column_greencertificates
        ></th>
        <th
          class="text-right align-top"
          scope="col"
          v-dynamic-content:pv_overview_column_savingscumulative
        >
          {{ content.pv_overview_column_savingscumulative }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="totalSubsidies">
        <td class="text-left">0</td>
        <td class="text-right"></td>
        <td class="text-right">
          <sup>&#9670;</sup>
          {{ totalSubsidies | formatCurrency }}
        </td>
        <td class="text-right text-primary">{{ totalSubsidies | formatCurrency }}</td>
      </tr>
      <tr v-for="(value, index) in quote.detailOverview.energyGenerated" :key="index">
        <td class="text-left">{{ index + 1 }}</td>
        <td class="text-right">{{ value | formatKwh }}</td>
        <td class="text-right">
          <span v-if="quote.detailOverview.invertersReplacementYearIndex === index + 1">**</span>
          <span>{{ quote.detailOverview.annualSavings[index] | formatCurrency }}</span>
        </td>
        <td
          v-if="
            quote.detailOverview.annualSubsidies &&
            Object.keys(quote.detailOverview.annualSubsidies).length > 0
          "
          class="text-right"
        >
          <div
            v-if="
              quote.detailOverview.annualSubsidies[index] &&
              quote.detailOverview.annualSubsidies[index] !== '0'
            "
          >
            {{ quote.detailOverview.annualSubsidies[index] | formatCurrency }}
          </div>
        </td>
        <td class="text-right text-primary">
          {{ quote.detailOverview.annualSavingsCumulative[index] | formatCurrency }}
        </td>
      </tr>
      <tr class="table-row-summary">
        <td class="text-left font-weight-bold" v-dynamic-content:pv_overview_total></td>
        <td class="text-right font-weight-bold">
          {{ quote.detailOverview.energyGeneratedTotal | formatKwh }}
        </td>
        <td class="text-right font-weight-bold">
          {{ quote.detailOverview.annualSavingsTotal | formatCurrency }}
        </td>
        <td
          v-if="
            quote.detailOverview.annualSubsidies &&
            Object.keys(quote.detailOverview.annualSubsidies).length > 0
          "
        ></td>
        <td class="text-right text-primary font-weight-bold"></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'DetailYearOverview',
  props: ['quote'],
  computed: {
    totalSubsidies() {
      return (
        (this.quote.detailOverview.pvSubsidy || 0) + (this.quote.detailOverview.batterySubsidy || 0)
      )
    },
  },
}
</script>
